import React from 'react';
import { SelectDropdownStyles, CheckboxContent } from '../styles';
import { Form, Row, Col} from 'antd';
import MutualFund from './MutualFund';
import Notice from './Notice';
import { withRouter } from 'react-router-dom';
import PropTypes from "prop-types";
import VanguardAccountNumber from "../../CommonComponents/InputComponent/VanguardAccountNumber";
import DropDownComponent from "../../CommonComponents/DropDownComponent/DropDown";
import { getpwUrl } from "../../../../../../../utils/commonUtil";
import DonorDetails from "./DonorDetails";

class MutualFundForm extends React.Component {

    render() { 
        const voiceVerificationUrl =`${getpwUrl()}${'/FAQs#voice-verification'}`;
        return (
            <>
                <Form hideRequiredMark id={'assetHeldatVG'+this.props.accountId+ this.props.contributionType}>
                    <Row>
                    {(this.props.contributionType === "securityGift" | this.props.contributionType === "mutualFund" & this.props.accountId === 0) ?
                        <Notice message={`<div>A signed Letter of authorization, available on the Funding instructions page, is required to complete this contribution. If donated assets are valued at more than $2 million, the form requires further authentication such as Vanguard Voice verification, Signature guarantee, or Medallion signature guarantee. <a target=_blank href=${voiceVerificationUrl}>Click here</a> for more information. Your contribution will not be processed until the form is received in good order.</div>`}/>
                        : null
                    }
                    </Row>
                    <Row>
                        <Col lg={{span:8}} md={{span:8}}>
                        <SelectDropdownStyles>
                            <DropDownComponent assetHeld="assetHeldatVG" accountId={this.props.accountId} contributionType={this.props.contributionType} label="Type of account in which assets are registered" traverse="corporateInformation" giftLength={this.props.count-1}/>
                        </SelectDropdownStyles>
                        </Col>
                    </Row>
                    { (this.props.type === "Corporation"||this.props.type === "Private Foundation" ) ?
                        <Row>
                        <DonorDetails assetHeld="assetHeldatVG" accountId={this.props.accountId} contributionType={this.props.contributionType} type={this.props.type} count={this.props.count-1}/>
                        </Row>
                        : null
                    }
                    <Row>
                    <Col lg={{span:8}} md={{span:8}}>
                            <VanguardAccountNumber assetHeld="assetHeldatVG" property="VGAccountNumber" label="Vanguard account number" accountId={this.props.accountId} contributionType={this.props.contributionType} placeHolder="If the assets are held in a brokerage account, enter the 8 digit account number. If the assets are held in a mutual fund account, enter only the account number" giftLength={this.props.count-1}/>
                    </Col>
                    </Row>
                    { (this.props.contributionType === "mutualFund") ?
                    <Row>
                        <CheckboxContent marginBottom="30px" mLB='0'>Entry of ticker symbol or fund number will automatically populate the remaining fields.</CheckboxContent>
                    </Row>
                    : ''
                    }
                    <Row>
                        <MutualFund assetHeld="assetHeldatVG" accountId={this.props.accountId} count={this.props.count} contributionType={this.props.contributionType}/>
                    </Row>

                </Form>
            </>
        )
    }
}

const MutualFundAccount = Form.create({ name: "mutualFundAccount" })(MutualFundForm);

MutualFundAccount.propTypes = {
    accountId: PropTypes.number,
    contributionType: PropTypes.string,
    type: PropTypes.string,
    count: PropTypes.number,
};

export default withRouter(MutualFundAccount);